const makeConstant = (value: number, unit = 'px') => ({
  value,
  unit,
  get label() {
    return `${this.value}${this.unit}`;
  },
});

export const AXIS_HEIGHT = makeConstant(32);
export const CARD_WIDTH = makeConstant(326);
export const COMPACT_CARD_WIDTH = makeConstant(226);
export const DRAFT_CARD_HEIGHT = makeConstant(215);
export const MAX_CARD_SUBITEMS_HEIGHT = makeConstant(172);
export const SUBITEM_HEIGHT = makeConstant(28);
export const SUBITEM_GAP = makeConstant(8);
export const COLUMN_HEADER_HEIGHT = makeConstant(32);
export const GRID_GAP = makeConstant(16);
export const ROW_HEIGHT_MIN = makeConstant(215);
export const ROW_HEADER_WIDTH = {
  vertical: makeConstant(32),
  horizontal: makeConstant(155),
};

export const DEFAULT_COLOR = '#2196F3';

export const SORTABLE_TYPES = {
  Card: 'Card',
  Cell: 'Cell',
  Header: 'Header',
} as const;

export type SortableTypesValue = (typeof SORTABLE_TYPES)[keyof typeof SORTABLE_TYPES];

export const COL_ROW_HIGHLIGHT_COLOR = '#f1f1f1';
